import { Box } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { updateLoader } from '../../redux/slices/loaderSlice'
import SearchAndMultiSelectInput from './SearchAndMultiSelectInput'
import { fetchGroups } from '../../services/groupsServices'

interface UserGroupTypeAttributeProps {
    label: string
    id: string
    value: any
    onChange: any
    errorMessage?: string
    required?: boolean
    disabled?: boolean
}

const UserGroupTypeAttribute = (
    props: UserGroupTypeAttributeProps,
): ReactElement => {
    const { label, id, value, onChange, errorMessage, required, disabled } =
        props

    const org = useAppSelector((state) => state.org.org)

    const dispatch = useAppDispatch()

    const [list, setList] = useState<any[]>([])

    const [selectedValues, setSelectedValues] = useState<string[]>([])

    useEffect(() => {
        if (value) {
            setSelectedValues(value)
        } else {
            setSelectedValues([])
        }
    }, [value])

    useEffect(() => {
        dispatch(updateLoader(true))

        const getRecords = async () => {
            const response = await fetchGroups(
                {
                    pageNumber: 1,
                    size: 10000,
                    searchText: '',
                    filterBy: '',
                    sortOrder: '',
                },
                org?.id || '',
            )
            const updateUserGroups = response?.groups?.map((item: any) => {
                return { ...item, ...{ id: item.groupId } }
            })
            setList(updateUserGroups)
        }
        getRecords()

        dispatch(updateLoader(false))
    }, [org])

    const onSelectRecord = (id: string, entityIds: any) => {
        onChange(id, entityIds)
    }

    return (
        <Box>
            <SearchAndMultiSelectInput
                label={label}
                id={id}
                value={selectedValues}
                onSelect={onSelectRecord}
                list={list}
                required={required}
                disabled={disabled}
                errorMessage={
                    !selectedValues.length && errorMessage ? errorMessage : ''
                }
            />
        </Box>
    )
}

export default UserGroupTypeAttribute
